/* eslint-disable max-len */
import React from 'react';
import PropTypes, {arrayOf, bool, func} from 'prop-types';
import Button from '@sinclair-digital/sbg-storyline-components/src/components/Button';
import classNames from 'classnames';
import styles from './MediaTags.scss';
import {angleLeft} from 'react-icons-kit/fa/angleLeft';
import Icon from '@sinclair-digital/sbg-storyline-components/src/components/Icon';
import {MediaTagsForm} from './MediaTagsForm';

/**
 * Media tags right panel to edit tags
 *
 *
 * @param {Object} props
 * @returns {JSX.Element}
 * @constructor
 */

export const MediaTagsRightPanel = ({
    isOpen,
    onSave,
    closePanel,
    tags,
    tagExcludes,
    isEditable,
}) => {

    return (
        <aside
            id="sda-right-panel-tags"
            className={classNames(
                styles.sdaRightPanelTags,
                {[styles.open]: isOpen},
            )}
        >
            <div className={styles.sdaRightPanelTagsContent}>
                <div className={styles.sdaRightPanelTagsBack} onClick={() => closePanel()}><Icon icon={angleLeft} />Back</div>
                <div className={styles.sdaRightPanelTagsFormContainer}>
                    <MediaTagsForm tags={tags} tagExcludes={tagExcludes} onSave={onSave} isEditable={isEditable} />
                </div>
                <div className={styles.sdaRightPanelTagsBtnContainer}>
                    <Button
                        displayType="secondary"
                        className={styles.sdaRightPanelTagsCancelBtn}
                        onClick={closePanel}>
                        cancel
                    </Button>
                </div>
            </div>
        </aside>
    );
};

MediaTagsRightPanel.propTypes = {
    isOpen: bool.isRequired,
    onSave: func.isRequired,
    closePanel: func.isRequired,
    tags: arrayOf({
        name: PropTypes.string,
        dimension: PropTypes.string,
        uuid: PropTypes.string,
        relevance: PropTypes.number,
        included: PropTypes.bool,
        removable: PropTypes.bool,
        userGenerated: PropTypes.bool,
        position: PropTypes.number,
    }).isRequired,
    tagExcludes: arrayOf({
        name: PropTypes.string,
        dimension: PropTypes.string,
        uuid: PropTypes.string,
        relevance: PropTypes.number,
        included: PropTypes.bool,
        removable: PropTypes.bool,
        userGenerated: PropTypes.bool,
        position: PropTypes.number,
    }),
    isEditable: bool,
};
